<h1 class="page-title">
  <i class="fa fa-heart small"></i> Tus experiencias favoritas
</h1>

<!-- Add loading indicator -->
<div *ngIf="loading" class="text-center py-4">
  <div class="spinner-border" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>

<div class="card mt-4">
  <div class="card-body p-4 row">
    <div class="col-lg-12">
      <div
        class="activities-container search-results row mb-4"
        infiniteScroll
        *ngIf="activities"
        [infiniteScrollDistance]="scrollDistance"
        [infiniteScrollThrottle]="throttle"
        (scrolled)="onScroll()"
      >
        <article
          *ngFor="let activity of activities; let i = index"
          class="activity col-12 col-md-6 col-lg-4 py-4"
        >
          <app-activity-card
            [activity]="activity"
            [isFooterActive]="true"
          ></app-activity-card>
        </article>
      </div>

      <div class="activities-container search-results row" *ngIf="!activities">
        <div class="col-12 d-flex not-found-container">
          <h2>No tienes experiencias favoritas...</h2>

          <p>¡Explora Venntur y añade alguna!</p>
        </div>
      </div>
    </div>
  </div>
</div>
